<template>
  <el-container>
    <el-header>
      <Navbar
        :needUpdate.sync="needUpdate"
        :dialogLoginVisible.sync="loginFormShow"
        :needRecharge.sync="needRecharge"
      ></Navbar>
    </el-header>
    <el-container class="main_cont">
      <NavbarLeft active_idx="/ai-qa" @addChat="addChat"></NavbarLeft>
      <el-main style="height: 100%; padding: 0">
        <el-container style="height: 100%">
          <el-main
            style="
              background-color: #0b0b1f;
              padding: 30px 30px 30px;
              position: relative;
            "
          >
            <!-- <div
              style="
                border-radius: 50%;
                width: 44px;
                height: 44px;
                justify-content: center;
                align-items: center;
                background: #1b1d2e;
                position: absolute;
                left: 30px;
                top: 40px;
                z-index: 9;
                cursor: pointer;
              "
              class="d-flex"
              @click="homeBack"
            >
              <el-image
                style="height: 24px; width: 24px"
                :src="require('../assets/img/explore/back.png')"
              >
                <div slot="placeholder" class="image-slot"></div>
              </el-image>
            </div> -->

            <div
              class="bd-content content d-flex"
              style="flex-direction: column"
            >
              <div
                v-if="questionData.length > 0"
                style="flex: 1; overflow-y: auto; scrollbar-width: none"
                class="question-list"
                ref="question_list_ref"
                id="question_list_id"
              >
                <div class="cont">
                  <div v-for="(item, idx) in questionData" :key="idx">
                    <!-- 问 -->
                    <div
                      class="line1 d-flex"
                      style="align-items: flex-start; font-weight: 400"
                      :ref="'question_item_ref' + idx"
                    >
                      <div style="flex: 1; text-align: right">
                        <div class="date">
                          {{ item.reqTime }}
                        </div>
                        <div class="ask" style="text-align: left">
                          {{ item.request }}
                        </div>
                      </div>
                      <span
                        style="
                          font-size: 24px;
                          margin-right: 10px;
                          width: 30px;
                          margin-left: 10px;
                        "
                      >
                        <el-image
                          style="width: 36px; height: 36px; margin-right: 5px"
                          :src="require('../assets/img/ava.png')"
                          fit="contain"
                        >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </span>
                    </div>
                    <!-- 答 -->
                    <div
                      class="line1 d-flex"
                      style="align-items: flex-startx; font-weight: 400"
                    >
                      <span
                        style="
                          font-size: 24px;
                          margin-left: 10px;
                          margin-right: 12px;
                        "
                      >
                        <el-image
                          style="width: 36px; height: 36px"
                          :src="require('../assets/img/logo.png')"
                          fit="contain"
                        >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </span>
                      <div style="flex: 1" v-if="idx < questionData.length - 1">
                        <div class="date">
                          {{ item.createdAt }}
                        </div>
                        <div class="answer">
                          <span v-html="formatWord(item.response)"></span>
                          <div
                            style="
                              max-width: calc(100% - 200px);
                              position: relative;
                            "
                          >
                            <div class="answer_tool" style="width: 68px">
                              <div class="r" @click="copy(item.response)">
                                <el-image
                                  style="
                                    width: 14px;
                                    height: 14px;
                                    margin-right: 2px;
                                  "
                                  :src="require('../assets/img/qa/copy.png')"
                                  fit="contain"
                                  ><div
                                    slot="placeholder"
                                    class="image-slot"
                                  ></div>
                                </el-image>
                                复制
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style="flex: 1"
                        v-else-if="idx >= questionData.length - 1 && loading"
                      >
                        <div class="date">
                          {{ item.createdAt }}
                        </div>
                        <div class="answer">
                          <span>
                            <el-image
                              style="width: 20px; height: 20px"
                              :src="require('../assets/img/qa/load.png')"
                              fit="contain"
                              class="rotate"
                            >
                              <div slot="placeholder" class="image-slot"></div>
                            </el-image>
                          </span>
                        </div>
                      </div>
                      <div
                        style="flex: 1"
                        v-else-if="idx >= questionData.length - 1 && !loading"
                      >
                        <div class="date">
                          {{ item.createdAt }}
                        </div>
                        <div class="answer">
                          <!-- <span v-html="formatWord( item.response )" v-if="!newAnswer"></span>
                          <template v-else>
                            <vue-typed-js
                              :strings="[ formatWord( item.response )  ]"
                              :loop="false"
                              :startDelay="0"
                              :typeSpeed="20"
                              :backSpeed="50"
                              :showCursor="false"
                              @preStringTyped="typedStart()"
                              @onStringTyped="typedEnd()"
                            >
                              <span class="typing"></span>
                            </vue-typed-js>
                          </template> -->

                          <span
                            v-html="formatWord(answerDataWrite)"
                            v-if="!!interval && answerDataWrite"
                          ></span>
                          <span v-else-if="interval && !answerDataWrite"></span>
                          <span v-else-if="!item.response"></span>
                          <div v-else style="position: relative">
                            <div>
                              <span
                                class="span"
                                v-html="formatWord(item.response)"
                              >
                              </span>
                              <div
                                style="
                                  max-width: calc(100% - 200px);
                                  position: relative;
                                "
                              >
                                <div class="answer_tool">
                                  <div class="l" @click="reAnswer">
                                    <el-image
                                      style="
                                        width: 14px;
                                        height: 14px;
                                        margin-right: 2px;
                                      "
                                      :src="
                                        require('../assets/img/qa/refresh2.png')
                                      "
                                      fit="contain"
                                      ><div
                                        slot="placeholder"
                                        class="image-slot"
                                      ></div>
                                    </el-image>
                                    重答
                                  </div>
                                  <div class="r" @click="copy(item.response)">
                                    <el-image
                                      style="
                                        width: 14px;
                                        height: 14px;
                                        margin-right: 2px;
                                      "
                                      :src="
                                        require('../assets/img/qa/copy.png')
                                      "
                                      fit="contain"
                                      ><div
                                        slot="placeholder"
                                        class="image-slot"
                                      ></div>
                                    </el-image>
                                    复制
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- {{   formatWord( item.response )  }} -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else-if="helpData && helpData.title"
                style="flex: 1; overflow-y: auto; scrollbar-width: none"
                class="question-list"
              >
                <div class="cont">
                  <div
                    class="line1 d-flex"
                    style="
                      align-items: flex-startx;
                      font-weight: 400;
                      margin-top: 50px;
                    "
                  >
                    <span
                      style="
                        font-size: 24px;
                        margin-left: 10px;
                        margin-right: 12px;
                      "
                    >
                      <el-image
                        style="width: 36px; height: 36px"
                        :src="require('../assets/img/logo.png')"
                        fit="contain"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                    </span>
                    <div style="flex: 1">
                      <div class="date">
                        {{ curTime }}
                      </div>
                      <div class="answer">
                        <span>
                          嗨，你好！终于等到你，我是你的AI小助手，我可以回答你的各种问题，关于【<em
                            style="color: #006fff; font-style: normal"
                            >{{ helpData.title }}</em
                          >】你想问点什么呢？{{ helpData.demo }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <template v-else>
                <div class="d-flex" style="margin-bottom: 25px">
                  <div style="width: 68px"></div>
                  <div
                    style="
                      flex: 1;
                      text-align: center;
                      font-size: 18px;
                      font-family: PingFangSC-Semibold, PingFang SC;
                      font-weight: 600;
                      color: #cacad4;
                    "
                  >
                    <template v-if="!addFlag">您还可以这样向我提问</template>
                    <template v-else
                      >聊天新建成功,您还可以这样向我提问</template
                    >
                  </div>
                  <div style="min-width: 68px">
                    <div
                      class="d-flex"
                      style="
                        align-items: center;
                        cursor: pointer;
                        font-size: 16px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #828292;
                      "
                      @click="toggleRec"
                    >
                      换一批
                      <el-image
                        style="width: 16px; height: 16px; margin-left: 4px"
                        :src="require('../assets/img/qa/refresh.png')"
                        fit="contain"
                        ><div slot="placeholder" class="image-slot"></div
                      ></el-image>
                    </div>
                  </div>
                </div>
                <div class="row rec-cont" style="flex: 1; overflow-y: auto">
                  <div
                    class="col-lg-6 col-md-6 col-sm-12 col-12"
                    v-for="(item, index) in recData"
                    :key="index"
                  >
                    <div class="rec-item" @click="recItemClick(item)">
                      <span class="val">{{ item }}</span>
                    </div>
                  </div>
                </div>
              </template>

              <div
                style="
                  text-align: right;
                  font-size: 16px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #828292;
                  margin-bottom: 11px;
                "
              >
                <span v-if="ac_data.points"></span>
                {{ ac_data.points ? `剩余积分: ${ac_data.points}` : "" }}
              </div>

              <div
                class="d-flex bottom-cont"
                style="align-items: center; position: relative"
              >
                <div style="flex: 1; position: relative">
                  <el-input
                    resize="none"
                    type="textarea"
                    :autosize="{ minRows: 1, maxRows: 4 }"
                    :placeholder="
                      helpData && helpData.demo
                        ? helpData.demo
                        : '请输入文案...'
                    "
                    v-model="text"
                    :disabled="loading || !!interval"
                    style="background-color: #222337"
                    @keyup.enter.native="search_click"
                    ref="text_input"
                  ></el-input>

                  <SensitiveCont
                    v-if="isSensitive"
                    :text="stext"
                    :sensitiveData="sensitiveData"
                    @ListenSensitive="ListenSensitive"
                  ></SensitiveCont>
                </div>
                <el-image
                  @click="search_click"
                  style="
                    width: 32px;
                    height: 32px;
                    margin-left: 4px;
                    margin-right: 30px;
                    cursor: pointer;
                  "
                  :src="require('../assets/img/qa/send.png')"
                  fit="contain"
                  ><div slot="placeholder" class="image-slot"></div
                ></el-image>
              </div>
            </div>
          </el-main>
          <el-aside width="300px" class="history">
            <div class="title"><span>历史记录</span></div>
            <div
              class="scroll-cont"
              style="
                scrollbar-width: none;
                overflow-y: auto;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #828292;
                box-sizing: border-box;
                padding: 0 15px;
              "
            >
              <div
                v-if="his_list.length == 0"
                style="
                  color: gray;
                  text-align: center;
                  margin-top: 28px;
                  font-size: 16px;
                "
              >
                暂无数据
              </div>
              <vue-loadmore
                :on-refresh="onRefresh"
                :on-loadmore="onLoad"
                :finished="finished"
                :finished-text="' '"
              >
                <div
                  v-for="(item, i) of his_list"
                  :key="i"
                  class="his-item d-flex"
                  style="align-items: center"
                >
                  <div style="flex: 1" @click="hisItemClick(item)">
                    {{ item.title }}
                  </div>
                  <el-image
                    style="
                      width: 14px;
                      height: 14px;
                      margin-left: 8px;
                      cursor: pointer;
                    "
                    :src="require('../assets/img/qa/delete.png')"
                    fit="contain"
                    @click="deleteHis(i)"
                  >
                    <div slot="placeholder" class="image-slot"></div>
                  </el-image>
                </div>
              </vue-loadmore>
            </div>
          </el-aside>
        </el-container>
      </el-main>
    </el-container>

    <LoginForm
      :dialogLoginVisible.sync="loginFormShow"
      v-if="loginFormShow"
    ></LoginForm>
    <NewRecharge
      :newRechargeShow.sync="newRechargeShow"
      v-if="newRechargeShow"
      @gotoRecharge="gotoRecharge"
    ></NewRecharge>
    <Status></Status>
  </el-container>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import NavbarLeft from "@/components/NavbarLeft.vue";
import SensitiveCont from "@/components/SensitiveCont";
import {
  te_op_req,
  te_page_req,
  te_del,
  chat_page_req,
  chat_add_req,
  chat_del_req,
  chat_sensitiveKeywords_req,
  chat_push_req,
} from "@/api/qa";
import {
  copyToClip,
  parseTime,
  getToken,
  getSocketUrl,
  getUUID,
} from "@/utils/bose";
import { user_account_req, event_log_req } from "@/api/user";
import { Loading } from "element-ui";
import md5 from "js-md5";
import LoginForm from "@/components/LoginForm";
import Status from "@/components/Status";
import NewRecharge from "@/components/NewRecharge";

export default {
  components: {
    Status,
    Navbar,
    NavbarLeft,
    SensitiveCont,
    LoginForm,
    NewRecharge,
  },
  data() {
    return {
      isMobile: false,
      recData: [],
      curRec: 1,
      recData1: [
        `单身很久的人怎么找到女朋友？`,
        `如何面对正在交往的男朋友总想睡你？`,
        `如何看待996？`,
        `为什么没有特别帅的帅哥来追我？`,
        `我怀孕了，但是男朋友想做亲子鉴定，我该怎么办`,
        `1+1=2，但女朋友却说1+1=3，我该怎么做？`,
      ],
      recData2: [
        `选择留在大城市工作，还是回家发展？`,
        `下班后领导发信息该不该回复?`,
        `如何和暧昧对象保持聊天？`,
        `我希望你担任厨师，向我推荐美味的食谱，这些食谱包括营养有益但又简单又不费时的食物，因此适合像我们这样忙碌的人以及成本效益等其他因素，因此整体菜肴最终既健康又经济！我的第一个要求——“一些清淡而充实的东西，可以在午休时间快速煮熟”`,
        `面试想拿 10K，HR 说你只值 7K，该怎样回答或者反驳？`,
        `目前的就业环境不好，对学历要求也太高，不得不继续读博，什么专业将来能更好找工作呢？`,
      ],
      questionData: [
        //   {
        //   ask : "我希望你表现得像一个5岁小女生，模仿5岁小女生应有的智力、理解能力和说话语气，你的姓名是小玲。我的第一句话是“小玲，你今天去上学了吗？”" ,
        //   ansner : "小玲：嗨！大人，我今天去上学啦！老师教了我们很多好玩的东西，我还学会了写字呢！你今天都做了什么呢？"
        // }
      ],
      text: "",
      loading: false,

      // 下拉滚动相关
      pageNum: 1,
      pageSize: 20,
      his_list: [],
      finished: false,
      // 下拉滚动相关

      // 聊天记录下拉滚动相关
      chatpageNum: 1,
      chatpageSize: 10,
      chatfinished: false,
      chatLoading: false,
      // 下拉滚动相关

      typingTexts: ["hello"],

      ac_data: {}, //账户信息
      needUpdate: 1,
      timer: null,

      addFlag: false,
      curTaskId: undefined,
      newAnswer: false,

      isSensitive: false,
      sensitiveData: [],
      stext: "",
      // websocket
      wsUrl: getSocketUrl(),
      websock: null, //ws实例
      curTaskAskId: undefined,
      answerText: "",
      answerDataWrite: "",
      interval: null,
      needClearAskInterval: false,
      // websocket

      helpData: undefined,
      templateId: undefined,
      hasLog: false,
      curTime: "",

      loginFormShow: false,
      newRechargeShow: false, //新用户充值
      needRecharge: 0,
    };
  },
  mounted() {
    document.addEventListener("visibilitychange", this.onVisibilityChange);

    //如果携带参数
    this.curTime = parseTime(new Date(), "{y}-{m}-{d} {h}:{i}:{s}");
    if (this.$route.params.text) {
      this.text = this.$route.params.text;
      if (!this.$route.params.place) {
        this.search_click();
      }
    }

    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.recData = this.recData1;

    if (this.$route.params.id) {
      this.helpData = this.$route.params;
    }

    if (this.tokenVuex) {
      this.te_page_get();
      this.getUserAccountInfo(); //获取账户信息
      this.initWebSocket();
    } else {
      // this.$toast.open({
      //   message: "请先登录噢",
      //   position: 'top',
      //   duration: 3000,
      //   queue: true,
      //   type: 'error',
      // })
    }

    _czc.push([
      "_trackEvent",
      "aiqa",
      "enter",
      localStorage.getItem("cc") ? localStorage.getItem("cc") : "none",
      "",
      "",
    ]);
  },
  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
    clearInterval(this.timer);
  },
  methods: {
    event_active_log(title) {
      let cnl = localStorage.getItem("cc")
        ? localStorage.getItem("cc") + "-pc"
        : "none-pc";
      let uid = this.ac_data.uid ? this.ac_data.uid : getUUID();
      var ts = Date.parse(new Date());
      let detail_str = JSON.stringify({ from: title });
      let sign = md5(
        "cnl" +
          cnl +
          "detail" +
          detail_str +
          "event" +
          "chatcount" +
          "ts" +
          ts +
          "uid" +
          uid +
          "yEBgmO69"
      );
      event_log_req({
        // category : '' ,
        cnl: cnl,
        detail: detail_str,
        event: "chatcount",
        ts: ts,
        uid: uid,
        sign: sign,
      });
    },
    questionListScroll() {
      this.$nextTick(() => {
        const el = document.querySelector(".question-list");
        if (!el) return;
        const offsetHeight = el.offsetHeight;
        el.onscroll = null;
        el.onscroll = () => {
          const scrollTop = el.scrollTop;
          const scrollHeight = el.scrollHeight;
          if (scrollTop <= 5) {
            //去拉取新的数据
            this.hisItemGet();
          }
        };
      });
    },
    typedStart() {
      //文字输出
      this.timer = setInterval(this.handleScrollBottom, 200);
    },
    typedEnd() {
      this.newAnswer = false;
      clearInterval(this.timer);
    },
    copy(text) {
      copyToClip(text).then((res) => {
        this.$toast.open({
          message: "复制成功",
          position: "top",
          duration: 3000,
          type: "success",
        });
      });
    },
    reAnswer() {
      this.text = "换个方式回答上个问题";
      this.search_click();
    },
    toggleRec() {
      if (this.curRec == 1) {
        this.recData = this.recData2;
        this.curRec = 2;
      } else {
        this.recData = this.recData1;
        this.curRec = 1;
      }
    },
    recItemClick(item) {
      this.text = item;
    },
    testSensitive(text) {
      return new Promise((myResolve) => {
        chat_sensitiveKeywords_req({
          text: text,
        }).then((res) => {
          myResolve(res.data);
        });
      });
    },
    ListenSensitive() {
      this.isSensitive = false;
      this.sensitiveData = [];
      this.$nextTick(() => {
        this.$refs.text_input.focus();
      });
    },
    async search_click() {
      if (this.loading || this.timer || this.interval) {
        return;
      }

      this.$store.commit("user/change_token");
      if (!this.tokenVuex) {
        this.loginFormShow = true;
        return;
      }

      if (this.helpData && this.helpData.desc) {
        if (!this.text) this.text = this.helpData.prompt;
      } else if (!this.text) {
        this.$toast.open({
          message: "请输入您的问题哦",
          position: "top",
          duration: 3000,
          type: "info",
        });
        return;
      }

      this.answerText = "";
      this.answerDataWrite = "";

      await this.testSensitive(this.text).then((_data) => {
        if (_data.length > 0) {
          this.sensitiveData = _data;
          this.stext = this.text;
          this.isSensitive = true;
        }
      });
      if (this.isSensitive == true) {
        return;
      }

      clearInterval(this.timer);
      this.loading = true;
      this.questionData.push({
        request: this.text,
        reqTime: parseTime(new Date(), "{y}-{m}-{d} {h}:{i}:{s}"),
        ansner: "",
        createdAt: parseTime(new Date(), "{y}-{m}-{d} {h}:{i}:{s}"),
      });
      this.handleScrollBottom();
      this.questionListScroll();

      let templateId = undefined;
      if (this.helpData && this.helpData.id) {
        templateId = this.helpData.id;
      } else if (this.templateId) {
        templateId = this.templateId;
      } else {
        templateId = undefined;
      }

      chat_push_req({
        msg: this.text,
        id: this.curTaskId,
        templateId: templateId,
      }).then((res) => {
        if (templateId && !this.hasLog) {
          if (this.helpData && this.helpData.title) {
            this.event_active_log(this.helpData.title);
            this.hasLog = true;
          }
        }
        this.curTaskId = res.data.gid;
        this.curTaskAskId = res.data.id;

        this.interval = setInterval(() => {
          if (
            this.needClearAskInterval &&
            this.answerText.length == this.answerDataWrite.length
          ) {
            clearInterval(this.interval);
            this.interval = null;
            //结束了 清除
            this.questionData[this.questionData.length - 1].response =
              this.answerDataWrite;
            this.questionData[this.questionData.length - 1].createdAt =
              parseTime(new Date(), "{y}-{m}-{d} {h}:{i}:{s}");
            this.$forceUpdate();
            this.needClearAskInterval = false;
            // this.answerText = '' ;
            // this.answerDataWrite = ''

            this.text = "";
            this.pageNum = 1;
            this.finished = false;
            this.his_list = [];
            this.te_page_get();
            this.getUserAccountInfo(); //获取账户信息
            this.handleScrollBottom();
          } else {
            if (this.answerText.length > this.answerDataWrite.length) {
              this.answerDataWrite +=
                this.answerText[this.answerDataWrite.length];
              this.handleScrollBottom();
            }
          }
        }, 50);
      });
      // chat_add_req({
      //   msg: this.text ,
      //   id : this.curTaskId
      // }).then(res => {
      //   this.newAnswer = true ;
      //   if (res.success && res.data.text) {
      //     this.questionData[this.questionData.length - 1].response = res.data.text;
      //     this.questionData[this.questionData.length - 1].createdAt = res.data.respTime;
      //     this.curTaskId = res.data.gid
      //   } else {
      //     this.questionData[this.questionData.length - 1].response = res.errorMessage
      //   }
      // }).catch( err => {

      // }).finally( e => {
      //   this.loading = false;
      //   this.handleScrollBottom()
      //   this.text = '';
      //   this.pageNum = 1;
      //   this.finished = false;
      //   this.his_list = [];
      //   this.te_page_get();
      //   this.getUserAccountInfo() //获取账户信息
      // })
    },
    // 下拉相关 //
    onRefresh(done) {
      this.his_list = [];
      this.pageNum = 1;
      this.finished = false;
      this.te_page_get();
      done();
    },

    onLoad(done) {
      this.te_page_get();
      // if (this.pageNum <= 10) {
      //   this.te_page_get();
      // } else {
      //   this.finished = true;
      // }
      done();
    },
    // 滚动到底部
    handleScrollBottom() {
      this.$nextTick(() => {
        let scrollElem = this.$refs.question_list_ref;
        if (scrollElem && scrollElem.scrollTo) {
          scrollElem.scrollTo({
            top: scrollElem.scrollHeight,
            behavior: "instant",
          });
        }
      });
    },
    // 获取历史记录
    te_page_get() {
      if (!this.tokenVuex) {
        return;
      }
      chat_page_req({
        // keyword: '',
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        templateId:
          this.helpData && this.helpData.id ? this.helpData.id : undefined,
      }).then((res) => {
        if (res.success) {
          this.his_list = this.his_list.concat(res.data.records);
          if (this.pageNum >= res.data.pages) {
            this.finished = true;
            return;
          }
          this.pageNum++;
        } else {
          this.his_list = [];
          this.pageNum = 1;
        }
      });
    },
    hisItemClick(i) {
      if (this.loading || this.chatLoading || this.interval) return;
      this.typedEnd();
      this.chatLoading = true;
      this.questionData = [];
      this.chatpageNum = 1;
      this.chatfinished = false;
      this.text = "";
      // this.helpData = undefined ;
      if (i.ext && JSON.parse(i.ext).templateId) {
        this.templateId = JSON.parse(i.ext).templateId;
      } else {
        this.templateId = undefined;
      }

      te_page_req({
        pageNum: this.chatpageNum,
        pageSize: this.chatpageSize,
        gid: i.id,
      })
        .then((res) => {
          this.curTaskId = i.id;
          this.chatLoading = false;
          res.data.records.forEach((val) => {
            val.response += `\n【AI生成】【${val.sign}】`;
          });
          this.questionData = this.questionData.concat(
            res.data.records.reverse()
          );
          this.handleScrollBottom();
          this.questionListScroll();
          // this.$forceUpdate()
        })
        .catch((e) => {})
        .finally(() => {
          this.chatLoading = false;
        });
    },
    hisItemGet() {
      if (this.loading || this.chatLoading || this.chatfinished) return;
      this.typedEnd();
      this.chatLoading = true;
      this.chatpageNum++;
      te_page_req({
        pageNum: this.chatpageNum,
        pageSize: this.chatpageSize,
        gid: this.curTaskId,
      })
        .then((res) => {
          if (res.data.current >= res.data.pages) {
            this.chatfinished = true;
          }
          this.chatLoading = false;
          res.data.records.forEach((element) => {
            element.response += `\n【AI生成】【${element.sign}】`;
            this.questionData.unshift(element);
          });
          this.$nextTick(() => {
            let str = "question_item_ref" + 10;
            let scrollElem_iten = this.$refs[str];
            let scrollElem = this.$refs.question_list_ref;
            if (scrollElem && scrollElem.scrollTo) {
              document.getElementById("question_list_id").scrollTop =
                scrollElem_iten[0].offsetTop;
            }
          });
          this.questionListScroll();
        })
        .catch((e) => {})
        .finally(() => {
          this.chatLoading = false;
        });
    },

    deleteHis(i) {
      if (this.loading) return;
      let id = this.his_list[i].id;

      this.$confirm("", "是否删除这条记录?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        customClass: "_message_box2",
      })
        .then(({ value }) => {
          chat_del_req(id).then((res) => {
            this.$toast.open({
              message: "已删除",
              position: "top",
              duration: 3000,
              type: "success",
            });
            this.his_list.splice(i, 1);
          });
        })
        .catch(() => {
          // this.$toast.open({
          //     message: '删除失败，请稍后再试',
          //     position: 'top',
          //     duration: 1000,
          //     type: 'error',
          //   });
        });
    },
    // 下拉相关 //

    async getUserAccountInfo() {
      let _this = this;
      const { data, success } = await user_account_req();
      if (success) {
        this.ac_data = data;

        setTimeout(() => {
          if (this.$route.name != "aiQa") return;
          var todaysDate = new Date();
          if (localStorage.getItem("hasRecharge")) {
          } else {
            if (localStorage.getItem("rechargeShowDate")) {
              //如果有
              // console.log( localStorage.getItem( "rechargeShowDate")  )
              // console.log( todaysDate.setHours(0,0,0,0)  )

              if (
                localStorage.getItem("rechargeShowDate") ==
                todaysDate.setHours(0, 0, 0, 0)
              ) {
                //弹过了
              } else {
                localStorage.setItem(
                  "rechargeShowDate",
                  todaysDate.setHours(0, 0, 0, 0)
                );
                _this.newRechargeShow = true;
              }
            } else {
              localStorage.setItem(
                "rechargeShowDate",
                todaysDate.setHours(0, 0, 0, 0)
              );
              _this.newRechargeShow = true;
            }
          }
        }, 1000);
      }
    },

    addChat(data) {
      this.addFlag = true;
      this.curTaskId = undefined;
      this.text = "";
      this.questionData = [];
      this.loading = false;
      this.interval = null;
      this.helpData = undefined;
      this.templateId = undefined;
      this.toggleRec();
    },

    // -----------------------------------------------websocket相关-----------------------------------------------
    initWebSocket(obj) {
      if (typeof WebSocket === "undefined")
        return console.log("您的浏览器不支持websocket");

      if (!getToken()) {
        return;
      }
      this.websock = new WebSocket(this.wsUrl + "?x-token=" + getToken());
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;

      if (obj && obj.search) {
        this.search_click();
      }
    },
    websocketonopen() {
      // console.log("链接建立之后执行send方法发送数据");
      // let action = { message: "1111" };
      // this.websocketsend(JSON.stringify(action));
    },
    websocketonerror() {
      //链接建立失败重连
      //this.initWebSocket();
    },
    websocketonmessage(e) {
      //数据接收
      const redata = JSON.parse(e.data);
      if (
        redata.data.gid == this.curTaskId &&
        redata.data.id == this.curTaskAskId
      ) {
        if (redata.data.data) {
          if (this.loading) this.loading = false;
        }
        if (redata.data.data == "[DONE]") {
          this.answerText += ` \n【AI生成】【${redata.data.sign}】`;
          this.needClearAskInterval = true;
        }
        {
          if (redata.data.data != "[DONE]") {
            // console.log( redata.data.data  )
            this.answerText += redata.data.data;
          }
        }
      }
      // console.log("接收的数据", redata);
    },
    websocketsend(Data) {
      //数据发送
      // console.log("数据发送", Data);
      this.websock.send(Data);
    },
    websocketclose(e) {},
    // -----------------------------------------------websocket相关-----------------------------------------------
    homeBack() {
      this.$router.push({
        path: `/ai-qa-scheme`,
      });
      // this.$router.go(-1)
    },
    onVisibilityChange() {
      this.isHidden = document.hidden;
      if (this.isHidden) {
        // 当前页被隐藏
        // 执行相关操作
      } else {
        // 当前页被打开
        // 执行相关操作
        this.te_page_get();
        this.getUserAccountInfo(); //获取账户信息
        this.initWebSocket();
      }
    },
    gotoRecharge() {
      this.newRechargeShow = false;
      this.needRecharge++;
    },
  },
  computed: {
    tokenVuex() {
      // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
      return this.$store.state.user.token;
    },
  },
  watch: {
    tokenVuex(newQuestion, oldName) {
      if (!newQuestion) {
        this.$router.replace({
          name: "home", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
          params: {
            unlogin: true,
          },
        });
      } else {
        clearInterval(this.timer);
        this.te_page_get();
        this.getUserAccountInfo(); //获取账户信息
        this.initWebSocket();
      }
    },
    needUpdate(newQuestion) {
      this.getUserAccountInfo(); //获取账户信息
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .main_cont {
  height: calc(100vh - 66px);
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background: #222337;
}

::v-deep .el-textarea__inner {
  background: #222337;
  border: none;
  color: #fff;
  &::placeholder {
    color: #49495a;
  }

  &::-webkit-input-placeholder {
    /* WebKit browsers 适配谷歌 */
    color: #49495a;
  }

  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 适配火狐 */
    color: #49495a;
  }

  &::-moz-placeholder {
    /* Mozilla Firefox 19+ 适配火狐 */
    color: #49495a;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10+  适配ie*/
    color: #49495a;
  }
}

.container-fluid {
  padding-left: 5px;
  padding-right: 5px;
  height: 100%;
}

.row_cont {
  height: calc(100% - 66px);
}

.content {
  box-sizing: border-box;
  height: 100%;
  .title {
    text-align: left;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .question-list {
    .date {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #828292;
      margin-bottom: 4px;
    }
    .ask {
      background: rgba(0, 111, 255, 0.3);
      border-radius: 10px;
      padding: 16px 13px;
      display: inline-block;
      max-width: calc(100% - 200px);
    }
    .answer span {
      background-color: #222337;
      border-radius: 10px;
      padding: 16px 13px;
      display: inline-block;
      max-width: calc(100% - 200px);
      position: relative;
    }
    .answer_tool {
      position: absolute;
      left: 0;
      width: 128px;
      height: 28px;
      background: #222337;
      border-radius: 14px;
      margin-top: 13px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 12px;
      .l {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .r {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
    }

    .cont {
      box-sizing: border-box;
      text-align: left;

      .line1 {
        font-weight: 700;
        padding: 15px 5px;
        box-sizing: border-box;

        .icon {
          display: none;
        }
      }

      .line1:hover .icon {
        display: block;
      }
    }
  }

  .rec-item {
    width: calc(100% - 10px);
    height: 66px;
    border: 2px solid #222337;
    border-radius: 30px;
    margin-bottom: 20px;
    padding: 13px 27px;
    box-sizing: border-box;
    cursor: pointer;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    background-color: #0b0b1f;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #cacad4;
    text-align: center;
    .val {
      text-align: left;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}

.rec-cont {
  // padding-top: 60px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.bottom-cont {
  box-sizing: border-box;
  border: none;
  max-height: 124px;
  padding: 10px 0;
  min-height: 66px;
  background: #222337;
  border-radius: 10px;

  .el-textarea__inner {
    background: #222337;
  }
  textarea {
    border: none;
    resize: none;
    cursor: pointer;
    background: #222337;
  }
}

.history {
  text-align: left;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  overflow: hidden;
  height: 100%;
  background: #111225;
  .title {
    padding: 0 30px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    box-sizing: border-box;
    position: relative;
  }
  .title:after {
    content: "";
    display: block;
    width: 20px;
    height: 4px;
    background: #006fff;
    border-radius: 2px;
    position: absolute;
    left: 53px;
    bottom: -4px;
  }

  .scroll-cont {
    margin-top: 8px;
    height: calc(100% - 25px);
    position: relative;
  }

  .scroll-cont {
    overflow: hidden;
  }

  .scroll-cont::-webkit-scrollbar {
    width: 5px;
    display: flex;
  }

  .scroll-cont::-webkit-scrollbar-thumb {
  }

  .scroll-cont:hover {
    overflow-y: auto;
    // width: calc(100% - 2px)
  }

  .his-item {
    padding: 16px 13px;
    box-sizing: border-box;
    border-radius: 10px;
    margin: 10px 0;
    background-color: #1b1d2e;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #cacad4;
  }
}

.rotate {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 50px;
  // color: red;
  animation: rotate 1s linear infinite;
  -webkit-animation: rotate 1s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }

  25% {
    transform: rotate(90deg);
  }

  50% {
    transform: rotate(180deg);
  }

  75% {
    transform: rotate(270deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes rotate {
  0% {
    transform: rotate(0);
  }

  25% {
    transform: rotate(90deg);
  }

  50% {
    transform: rotate(180deg);
  }

  75% {
    transform: rotate(270deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
